export const addressJsonData = [
  {
    id: 100,
    name: "Улаанбаатар",
    code: "ub",
    duureg: [
      {
        id: 101,
        name: "Багануур",
        duureg: [
          { id: 1, name: "1-р хороо" },
          { id: 2, name: "2-р хороо" },
          { id: 3, name: "3-р хороо" },
          { id: 4, name: "4-р хороо" },
          { id: 5, name: "5-р хороо" },
        ],
      },
      {
        id: 102,
        name: "Багахангай",
        duureg: [
          { id: 6, name: "1-р хороо" },
          { id: 7, name: "2-р хороо" },
        ],
      },
      {
        id: 103,
        name: "Баянгол",
        duureg: [
          { id: 8, name: "1-р хороо" },
          { id: 9, name: "2-р хороо" },
          { id: 10, name: "3-р хороо" },
          { id: 11, name: "4-р хороо" },
          { id: 12, name: "5-р хороо" },
          { id: 13, name: "6-р хороо" },
          { id: 14, name: "7-р хороо" },
          { id: 15, name: "8-р хороо" },
          { id: 16, name: "9-р хороо" },
          { id: 17, name: "10-р хороо" },
          { id: 18, name: "11-р хороо" },
          { id: 19, name: "12-р хороо" },
          { id: 20, name: "13-р хороо" },
          { id: 21, name: "14-р хороо" },
          { id: 22, name: "15-р хороо" },
          { id: 23, name: "16-р хороо" },
          { id: 24, name: "17-р хороо" },
          { id: 25, name: "18-р хороо" },
          { id: 26, name: "19-р хороо" },
          { id: 27, name: "20-р хороо" },
          { id: 28, name: "21-р хороо" },
          { id: 29, name: "22-р хороо" },
          { id: 30, name: "23-р хороо" },
          { id: 31, name: "24-р хороо" },
          { id: 32, name: "25-р хороо" },
          { id: 33, name: "26-р хороо" },
          { id: 34, name: "27-р хороо" },
          { id: 35, name: "28-р хороо" },
          { id: 36, name: "29-р хороо" },
          { id: 37, name: "30-р хороо" },
          { id: 38, name: "31-р хороо" },
          { id: 39, name: "32-р хороо" },
          { id: 40, name: "33-р хороо" },
          { id: 41, name: "34-р хороо" },
        ],
      },
      {
        id: 104,
        name: "Баянзүрх",
        duureg: [
          { id: 42, name: "1-р хороо" },
          { id: 43, name: "2-р хороо" },
          { id: 44, name: "3-р хороо" },
          { id: 45, name: "4-р хороо" },
          { id: 46, name: "5-р хороо" },
          { id: 47, name: "6-р хороо" },
          { id: 48, name: "7-р хороо" },
          { id: 49, name: "8-р хороо" },
          { id: 50, name: "9-р хороо" },
          { id: 51, name: "10-р хороо" },
          { id: 52, name: "11-р хороо" },
          { id: 53, name: "12-р хороо" },
          { id: 54, name: "13-р хороо" },
          { id: 55, name: "14-р хороо" },
          { id: 56, name: "15-р хороо" },
          { id: 57, name: "16-р хороо" },
          { id: 58, name: "17-р хороо" },
          { id: 59, name: "18-р хороо" },
          { id: 60, name: "19-р хороо" },
          { id: 61, name: "20-р хороо" },
          { id: 62, name: "21-р хороо" },
          { id: 63, name: "22-р хороо" },
          { id: 64, name: "23-р хороо" },
          { id: 65, name: "24-р хороо" },
          { id: 66, name: "25-р хороо" },
          { id: 67, name: "26-р хороо" },
          { id: 68, name: "27-р хороо" },
          { id: 69, name: "28-р хороо" },
          { id: 70, name: "29-р хороо" },
          { id: 71, name: "30-р хороо" },
          { id: 72, name: "31-р хороо" },
          { id: 73, name: "32-р хороо" },
          { id: 74, name: "33-р хороо" },
          { id: 75, name: "34-р хороо" },
          { id: 76, name: "35-р хороо" },
          { id: 77, name: "36-р хороо" },
          { id: 78, name: "37-р хороо" },
          { id: 79, name: "38-р хороо" },
          { id: 80, name: "39-р хороо" },
          { id: 81, name: "40-р хороо" },
          { id: 82, name: "41-р хороо" },
          { id: 83, name: "42-р хороо" },
          { id: 84, name: "43-р хороо" },
        ],
      },
      {
        id: 105,
        name: "Налайх",
        duureg: [
          { id: 85, name: "1-р хороо" },
          { id: 86, name: "2-р хороо" },
          { id: 87, name: "3-р хороо" },
          { id: 88, name: "4-р хороо" },
          { id: 89, name: "5-р хороо" },
          { id: 90, name: "6-р хороо" },
          { id: 91, name: "7-р хороо" },
          { id: 92, name: "8-р хороо" },
        ],
      },
      {
        id: 106,
        name: "Сонгинохайрхан",
        duureg: [
          { id: 93, name: "1-р хороо" },
          { id: 94, name: "2-р хороо" },
          { id: 95, name: "3-р хороо" },
          { id: 96, name: "4-р хороо" },
          { id: 97, name: "5-р хороо" },
          { id: 98, name: "6-р хороо" },
          { id: 99, name: "7-р хороо" },
          { id: 100, name: "8-р хороо" },
          { id: 101, name: "9-р хороо" },
          { id: 102, name: "10-р хороо" },
          { id: 103, name: "11-р хороо" },
          { id: 104, name: "12-р хороо" },
          { id: 105, name: "13-р хороо" },
          { id: 106, name: "14-р хороо" },
          { id: 107, name: "15-р хороо" },
          { id: 108, name: "16-р хороо" },
          { id: 109, name: "17-р хороо" },
          { id: 110, name: "18-р хороо" },
          { id: 111, name: "19-р хороо" },
          { id: 112, name: "20-р хороо" },
          { id: 113, name: "21-р хороо" },
          { id: 114, name: "22-р хороо" },
          { id: 115, name: "23-р хороо" },
          { id: 116, name: "24-р хороо" },
          { id: 117, name: "25-р хороо" },
          { id: 118, name: "26-р хороо" },
          { id: 119, name: "27-р хороо" },
          { id: 120, name: "28-р хороо" },
          { id: 121, name: "29-р хороо" },
          { id: 122, name: "30-р хороо" },
          { id: 123, name: "31-р хороо" },
          { id: 124, name: "32-р хороо" },
          { id: 125, name: "33-р хороо" },
          { id: 126, name: "34-р хороо" },
          { id: 127, name: "35-р хороо" },
          { id: 128, name: "36-р хороо" },
          { id: 129, name: "37-р хороо" },
          { id: 130, name: "38-р хороо" },
          { id: 131, name: "39-р хороо" },
          { id: 132, name: "40-р хороо" },
          { id: 133, name: "41-р хороо" },
          { id: 134, name: "42-р хороо" },
          { id: 135, name: "43-р хороо" },
        ],
      },
      {
        id: 107,
        name: "Сүхбаатар",
        duureg: [
          { id: 136, name: "1-р хороо" },
          { id: 137, name: "2-р хороо" },
          { id: 138, name: "3-р хороо" },
          { id: 139, name: "4-р хороо" },
          { id: 140, name: "5-р хороо" },
          { id: 141, name: "6-р хороо" },
          { id: 142, name: "7-р хороо" },
          { id: 143, name: "8-р хороо" },
          { id: 144, name: "9-р хороо" },
          { id: 145, name: "10-р хороо" },
          { id: 146, name: "11-р хороо" },
          { id: 147, name: "12-р хороо" },
          { id: 148, name: "13-р хороо" },
          { id: 149, name: "14-р хороо" },
          { id: 150, name: "15-р хороо" },
          { id: 151, name: "16-р хороо" },
          { id: 152, name: "17-р хороо" },
          { id: 153, name: "18-р хороо" },
          { id: 154, name: "19-р хороо" },
          { id: 155, name: "20-р хороо" },
        ],
      },
      {
        id: 108,
        name: "Хан-Уул",
        duureg: [
          { id: 156, name: "1-р хороо" },
          { id: 157, name: "2-р хороо" },
          { id: 158, name: "3-р хороо" },
          { id: 159, name: "4-р хороо" },
          { id: 160, name: "5-р хороо" },
          { id: 161, name: "6-р хороо" },
          { id: 162, name: "7-р хороо" },
          { id: 163, name: "8-р хороо" },
          { id: 164, name: "9-р хороо" },
          { id: 165, name: "10-р хороо" },
          { id: 166, name: "11-р хороо" },
          { id: 167, name: "12-р хороо" },
          { id: 168, name: "13-р хороо" },
          { id: 169, name: "14-р хороо" },
          { id: 170, name: "15-р хороо" },
          { id: 171, name: "16-р хороо" },
          { id: 172, name: "17-р хороо" },
          { id: 173, name: "18-р хороо" },
          { id: 174, name: "19-р хороо" },
          { id: 175, name: "20-р хороо" },
          { id: 176, name: "21-р хороо" },
          { id: 177, name: "22-р хороо" },
          { id: 178, name: "23-р хороо" },
          { id: 179, name: "24-р хороо" },
          { id: 180, name: "25-р хороо" },
        ],
      },
      {
        id: 109,
        name: "Чингэлтэй",
        duureg: [
          { id: 181, name: "1-р хороо" },
          { id: 182, name: "2-р хороо" },
          { id: 183, name: "3-р хороо" },
          { id: 184, name: "4-р хороо" },
          { id: 185, name: "5-р хороо" },
          { id: 186, name: "6-р хороо" },
          { id: 187, name: "7-р хороо" },
          { id: 188, name: "8-р хороо" },
          { id: 189, name: "9-р хороо" },
          { id: 190, name: "10-р хороо" },
          { id: 191, name: "11-р хороо" },
          { id: 192, name: "12-р хороо" },
          { id: 193, name: "13-р хороо" },
          { id: 194, name: "14-р хороо" },
          { id: 195, name: "15-р хороо" },
          { id: 196, name: "16-р хороо" },
          { id: 197, name: "17-р хороо" },
          { id: 198, name: "18-р хороо" },
          { id: 199, name: "19-р хороо" },
          { id: 200, name: "20-р хороо" },
          { id: 201, name: "21-р хороо" },
          { id: 202, name: "22-р хороо" },
          { id: 203, name: "23-р хороо" },
          { id: 204, name: "24-р хороо" },
          { id: 205, name: "25-р хороо" },
        ],
      },
      {
        id: 110,
        name: "Эрдэнэт хот",
        duureg: [],
      },
    ],
  },
  {
    id: 2,
    name: "Архангай",
    code: "ar",
    duureg: [
      { id: 201, name: "Батцэнгэл" },
      { id: 202, name: "Булган" },
      { id: 203, name: "Жаргалант" },
      { id: 204, name: "Ихтамир" },
      { id: 205, name: "Өгийнуур" },
      { id: 206, name: "Өлзийт" },
      { id: 207, name: "Өндөр-Улаан" },
      { id: 208, name: "Тариат" },
      { id: 209, name: "Төвшрүүлэх" },
      { id: 210, name: "Хайрхан" },
      { id: 211, name: "Хангай" },
      { id: 212, name: "Хашаат" },
      { id: 213, name: "Хотонт" },
      { id: 214, name: "Цахир" },
      { id: 215, name: "Цэнхэр" },
      { id: 216, name: "Цэцэрлэг" },
      { id: 217, name: "Чулуут" },
      {
        id: 218,
        name: "Эрдэнэбулган",
        branch: "arkhangai",
        code: "251015000345100000",
      },
      { id: 219, name: "Эрдэнэмандал" },
    ],
  },
  {
    id: 3,
    name: "Баян-Өлгий",
    code: "bo",
    duureg: [
      { id: 301, name: "Алтай" },
      { id: 302, name: "Алтанцөгц" },
      { id: 303, name: "Баяннуур" },
      { id: 304, name: "Бугат" },
      { id: 305, name: "Булган" },
      { id: 306, name: "Буянт" },
      { id: 307, name: "Дэлүүн" },
      { id: 308, name: "Ногооннуур" },
      {
        id: 309,
        name: "Өлгий",
        branch: "ulgii",
        code: "220733168857700000",
      },
      { id: 310, name: "Сагсай" },
      { id: 311, name: "Толбо" },
      { id: 312, name: "Улаанхус" },
      { id: 313, name: "Цэнгэл" },
    ],
  },
  {
    id: 4,
    name: "Баянхонгор",
    code: "ba",
    duureg: [
      { id: 401, name: "Баацагаан" },
      { id: 402, name: "Баянбулаг" },
      { id: 403, name: "Баянговь" },
      { id: 404, name: "Баянлиг" },
      { id: 405, name: "Баян-Овоо" },
      { id: 406, name: "Баян-Өндөр" },
      {
        id: 407,
        name: "Баянхонгор",
        branch: "bayankhongor",
        code: "241205000391700000",
      },
      { id: 408, name: "Баянцагаан" },
      { id: 409, name: "Богд" },
      { id: 410, name: "Бөмбөгөр" },
      { id: 411, name: "Бууцагаан" },
      { id: 412, name: "Галуут" },
      { id: 413, name: "Гурванбулаг" },
      { id: 414, name: "Жаргалант" },
      { id: 415, name: "Жинст" },
      { id: 416, name: "Заг" },
      { id: 417, name: "Өлзийт" },
      { id: 418, name: "Хүрээмарал" },
      { id: 419, name: "Шинэжинст" },
      { id: 420, name: "Эрдэнэцогт" },
    ],
  },
  {
    id: 5,
    name: "Булган",
    code: "bu",
    duureg: [
      { id: 501, name: "Баян-Агт" },
      { id: 502, name: "Баяннуур" },
      { id: 503, name: "Бугат" },
      { id: 504, name: "Булган" },
      { id: 505, name: "Бүрэгхангай" },
      { id: 506, name: "Гурванбулаг" },
      { id: 507, name: "Дашинчилэн" },
      { id: 508, name: "Могод" },
      { id: 509, name: "Орхон" },
      { id: 510, name: "Рашаант" },
      { id: 511, name: "Сайхан" },
      { id: 512, name: "Сэлэнгэ" },
      { id: 513, name: "Тэшиг" },
      { id: 514, name: "Хангал" },
      { id: 515, name: "Хишиг-Өндөр" },
      { id: 516, name: "Хутаг-Өндөр" },
    ],
  },
  {
    id: 6,
    name: "Говь-Алтай",
    code: "ga",
    duureg: [
      { id: 601, name: "Алтай" },
      { id: 602, name: "Баян-Уул" },
      { id: 603, name: "Бигэр" },
      { id: 604, name: "Бугат" },
      { id: 605, name: "Дарви" },
      { id: 606, name: "Дэлгэр" },
      { id: 607, name: "Есөнбулаг" },
      { id: 608, name: "Жаргалан" },
      { id: 609, name: "Тайшир" },
      { id: 610, name: "Тонхил" },
      { id: 611, name: "Төгрөг" },
      { id: 612, name: "Халиун" },
      { id: 613, name: "Хөхморьт" },
      { id: 614, name: "Цогт" },
      { id: 615, name: "Цээл" },
      { id: 616, name: "Чандмань" },
      { id: 617, name: "Шарга" },
      { id: 618, name: "Эрдэнэ" },
    ],
  },
  {
    id: 7,
    name: "Говьсүмбэр",
    code: "gs",
    duureg: [
      { id: 701, name: "Баянтал" },
      { id: 702, name: "Сүмбэр" },
      { id: 703, name: "Шивээговь" },
    ],
  },
  {
    id: 8,
    name: "Дархан-Уул",
    code: "da",
    duureg: [
      {
        id: 801,
        name: "Дархан",
        branch: "darkhan",
        code: "2007121500010",
      },
      { id: 802, name: "Орхон" },
      { id: 803, name: "Хонгор" },
      { id: 804, name: "Шарынгол" },
    ],
  },
  {
    id: 9,
    name: "Дорноговь",
    code: "dg",
    duureg: [
      { id: 901, name: "Айраг" },
      { id: 902, name: "Алтанширээ" },
      { id: 903, name: "Даланжаргалан" },
      { id: 904, name: "Дэлгэрэх" },
      {
        id: 909,
        name: "Сайншанд",
        branch: "dornogovi",
        code: "150421495744300001",
      },
      {
        id: 905,
        name: "Замын-Үүд",
        branch: "zamiinuud",
        code: "200605133492300000",
      },
      { id: 906, name: "Иххэт" },
      { id: 907, name: "Мандах" },
      { id: 908, name: "Өргөн" },
      { id: 910, name: "Сайхандулаан" },
      { id: 911, name: "Улаанбадрах" },
      { id: 912, name: "Хатанбулаг" },
      { id: 913, name: "Хөвсгөл" },
      { id: 914, name: "Эрдэнэ" },
    ],
  },
  {
    id: 10,
    name: "Дорнод",
    code: "do",
    duureg: [
      { id: 1001, name: "Баяндун" },
      { id: 1002, name: "Баянтүмэн" },
      { id: 1003, name: "Баян-Уул" },
      { id: 1004, name: "Булган" },
      { id: 1005, name: "Гурванзагал" },
      { id: 1006, name: "Дашбалбар" },
      { id: 1007, name: "Матад" },
      { id: 1008, name: "Сэргэлэн" },
      { id: 1009, name: "Халхгол" },
      { id: 1010, name: "Хөлөнбуйр" },
      {
        id: 1011,
        name: "Хэрлэн",
        branch: "dornod",
        code: "198912290000000001",
      },
      { id: 1012, name: "Цагаан-Овоо" },
      { id: 1013, name: "Чойбалсан" },
      { id: 1014, name: "Чулуунхороот" },
    ],
  },
  {
    id: 11,
    name: "Дундговь",
    code: "du",
    duureg: [
      { id: 1101, name: "Адаацаг" },
      { id: 1102, name: "Баянжаргалан" },
      { id: 1103, name: "Говь-Угтаал" },
      { id: 1104, name: "Гурвансайхан" },
      { id: 1105, name: "Дэлгэрхангай" },
      { id: 1106, name: "Дэлгэрцогт" },
      { id: 1107, name: "Дэрэн" },
      { id: 1108, name: "Луус" },
      { id: 1109, name: "Өлзийт" },
      { id: 1110, name: "Өндөршил" },
      {
        id: 1111,
        name: "Сайнцагаан",
        branch: "mandalgovi",
        code: "220804171646000000",
      },
      { id: 1112, name: "Сайхан-Овоо" },
      { id: 1113, name: "Хулд" },
      { id: 1114, name: "Цагаандэлгэр" },
      { id: 1115, name: "Эрдэнэдалай" },
    ],
  },
  {
    id: 12,
    name: "Завхан",
    code: "za",
    duureg: [
      { id: 1201, name: "Алдархаан" },
      { id: 1202, name: "Асгат" },
      { id: 1203, name: "Баянтэс" },
      { id: 1204, name: "Баянхайрхан" },
      { id: 1205, name: "Дөрвөлжин" },
      { id: 1206, name: "Завханмандал" },
      { id: 1207, name: "Идэр" },
      { id: 1208, name: "Их-Уул" },
      { id: 1209, name: "Нөмрөг" },
      { id: 1210, name: "Отгон" },
      { id: 1211, name: "Сантмаргац" },
      { id: 1212, name: "Сонгино" },
      { id: 1213, name: "Тосонцэнгэл" },
      { id: 1214, name: "Түдэвтэй" },
      { id: 1215, name: "Тэлмэн" },
      { id: 1216, name: "Тэс" },
      { id: 1217, name: "Улиастай" },
      { id: 1218, name: "Ургамал" },
      { id: 1219, name: "Цагаанхайрхан" },
      { id: 1220, name: "Цагаанчулуут" },
      { id: 1221, name: "Цэцэн-Уул" },
      { id: 1222, name: "Шилүүстэй" },
      { id: 1223, name: "Эрдэнэхайрхан" },
      { id: 1224, name: "Яруу" },
    ],
  },
  {
    id: 13,
    name: "Орхон",
    code: "or",
    duureg: [
      {
        id: 1301,
        name: "Баян-Өндөр",
        branch: "erdenet",
        code: "201310110000000001",
      },
      { id: 1302, name: "Жаргалант" },
    ],
  },
  {
    id: 14,
    name: "Өвөрхангай",
    code: "ov",
    duureg: [
      {
        id: 1401,
        name: "Арвайхээр",
        branch: "arvaikheer",
        code: "190626618269100000",
      },
      { id: 1402, name: "Баруунбаян-Улаан" },
      { id: 1403, name: "Бат-Өлзий" },
      { id: 1404, name: "Баян-Өндөр" },
      { id: 1405, name: "Баянгол" },
      { id: 1406, name: "Богд" },
      { id: 1407, name: "Бүрд" },
      { id: 1408, name: "Гучин-Ус" },
      { id: 1409, name: "Есөнзүйл" },
      { id: 1410, name: "Зүүнбаян-Улаан" },
      { id: 1411, name: "Нарийнтээл" },
      { id: 1412, name: "Өлзийт" },
      { id: 1413, name: "Сант" },
      { id: 1414, name: "Тарагт" },
      { id: 1415, name: "Төгрөг" },
      { id: 1416, name: "Уянга" },
      { id: 1417, name: "Хайрхандулаан" },
      { id: 1418, name: "Хархорин" },
      { id: 1419, name: "Хужирт" },
    ],
  },
  {
    id: 15,
    name: "Өмнөговь",
    code: "om",
    duureg: [
      { id: 1501, name: "Баяндалай" },
      { id: 1502, name: "Баян-Овоо" },
      { id: 1503, name: "Булган" },
      { id: 1504, name: "Гурвантэс" },
      {
        id: 1505,
        name: "Даланзадгад",
        branch: "dalanzadgad",
        code: "201109270000000001",
      },
      { id: 1506, name: "Мандал-Овоо" },
      { id: 1507, name: "Манлай" },
      { id: 1508, name: "Ноён" },
      { id: 1509, name: "Номгон" },
      { id: 1510, name: "Сэврэй" },
      { id: 1511, name: "Ханбогд" },
      { id: 1512, name: "Ханхонгор" },
      { id: 1513, name: "Хүрмэн" },
      { id: 1514, name: "Цогт-Овоо" },
      { id: 1515, name: "Цогтцэций" },
    ],
  },
  {
    id: 16,
    name: "Сүхбаатар",
    code: "su",
    duureg: [
      { id: 1601, name: "Асгат" },
      {
        id: 1602,
        name: "Баруун-Урт",
        branch: "sukhbaatar",
        code: "201312240000000001",
      },
      { id: 1603, name: "Баяндэлгэр" },
      { id: 1604, name: "Дарьганга" },
      { id: 1605, name: "Мөнххаан" },
      { id: 1606, name: "Наран" },
      { id: 1607, name: "Онгон" },
      { id: 1608, name: "Сүхбаатар" },
      { id: 1609, name: "Түвшинширээ" },
      { id: 1610, name: "Түмэнцогт" },
      { id: 1611, name: "Уулбаян" },
      { id: 1612, name: "Халзан" },
      { id: 1613, name: "Эрдэнэцагаан" },
    ],
  },
  {
    id: 17,
    name: "Сэлэнгэ",
    code: "se",
    duureg: [
      { id: 1701, name: "Алтанбулаг" },
      { id: 1702, name: "Баруунбүрэн" },
      { id: 1703, name: "Баянгол" },
      { id: 1704, name: "Ерөө" },
      { id: 1705, name: "Жавхлант" },
      { id: 1706, name: "Зүүнбүрэн" },
      { id: 1707, name: "Мандал" },
      { id: 1708, name: "Орхон" },
      { id: 1709, name: "Орхонтуул" },
      { id: 1710, name: "Сант" },
      { id: 1711, name: "Сайхан" },
      { id: 1712, name: "Сүхбаатар" },
      { id: 1713, name: "Түшиг" },
      { id: 1714, name: "Хүдэр" },
      { id: 1715, name: "Хушаат" },
      { id: 1716, name: "Цагааннуур" },
      { id: 1717, name: "Шаамар" },
    ],
  },
  {
    id: 18,
    name: "Төв",
    code: "to",
    duureg: [
      { id: 1801, name: "Алтанбулаг" },
      { id: 1802, name: "Аргалант" },
      { id: 1803, name: "Архуст" },
      { id: 1804, name: "Батсүмбэр" },
      { id: 1805, name: "Баян" },
      { id: 1806, name: "Баяндэлгэр" },
      { id: 1807, name: "Баянжаргалан" },
      { id: 1808, name: "Баян-Өнжүүл" },
      { id: 1809, name: "Баянхангай" },
      { id: 1810, name: "Баянцагаан" },
      { id: 1811, name: "Баянцогт" },
      { id: 1812, name: "Баянчандмань" },
      { id: 1813, name: "Борнуур" },
      { id: 1814, name: "Бүрэн" },
      { id: 1815, name: "Дэлгэрхаан" },
      { id: 1816, name: "Жаргалант" },
      { id: 1817, name: "Заамар" },
      {
        id: 1818,
        name: "Зуунмод",
        branch: "zuunmod",
        code: "181227350099900000",
      },
      { id: 1819, name: "Лүн" },
      { id: 1820, name: "Мөнгөнморьт" },
      { id: 1821, name: "Өндөрширээт" },
      { id: 1822, name: "Сүмбэр" },
      { id: 1823, name: "Сэргэлэн" },
      { id: 1824, name: "Угтаалцайдам" },
      { id: 1825, name: "Цээл" },
      { id: 1826, name: "Эрдэнэ" },
      { id: 1827, name: "Эрдэнэсант" },
    ],
  },
  {
    id: 19,
    name: "Увс",
    code: "uv",
    duureg: [
      { id: 1901, name: "Баруунтуруун" },
      { id: 1902, name: "Бөхмөрөн" },
      { id: 1903, name: "Давст" },
      { id: 1904, name: "Завхан" },
      { id: 1905, name: "Зүүнговь" },
      { id: 1906, name: "Зүүнхангай" },
      { id: 1907, name: "Малчин" },
      { id: 1908, name: "Наранбулаг" },
      { id: 1909, name: "Өлгий" },
      { id: 1910, name: "Өмнөговь" },
      { id: 1911, name: "Өндөрхангай" },
      { id: 1912, name: "Сагил" },
      { id: 1913, name: "Тариалан" },
      { id: 1914, name: "Тэс" },
      { id: 1915, name: "Түргэн" },
      {
        id: 1916,
        name: "Улаангом",
        branch: "uvs",
        code: "200613142471000000",
      },
      { id: 1917, name: "Ховд" },
      { id: 1918, name: "Хяргас" },
      { id: 1919, name: "Цагаанхайрхан" },
    ],
  },
  {
    id: 20,
    name: "Ховд",
    code: "ho",
    duureg: [
      { id: 2001, name: "Алтай" },
      { id: 2002, name: "Булган" },
      { id: 2003, name: "Буянт" },
      { id: 2004, name: "Дарви" },
      { id: 2005, name: "Дөргөн" },
      { id: 2006, name: "Дуут" },
      {
        id: 2007,
        name: "Жаргалант",
        branch: "khovd",
        code: "2007121500012",
      },
      { id: 2008, name: "Зэрэг" },
      { id: 2009, name: "Манхан" },
      { id: 2010, name: "Мөнххайрхан" },
      { id: 2011, name: "Мөст" },
      { id: 2012, name: "Мянгад" },
      { id: 2013, name: "Үенч" },
      { id: 2014, name: "Ховд" },
      { id: 2015, name: "Чандмань" },
      { id: 2016, name: "Цэцэг" },
      { id: 2017, name: "Эрдэнэбүрэн" },
    ],
  },
  {
    id: 21,
    name: "Хөвсгөл",
    code: "hu",
    duureg: [
      { id: 2101, name: "Алаг-Эрдэнэ" },
      { id: 2102, name: "Арбулаг" },
      { id: 2103, name: "Баянзүрх" },
      { id: 2104, name: "Бүрэнтогтох" },
      { id: 2105, name: "Галт" },
      { id: 2106, name: "Жаргалант" },
      { id: 2107, name: "Их-Уул" },
      {
        id: 2108,
        name: "Мөрөн",
        branch: "khuvsgul",
        code: "180606117831300000",
      },
      { id: 2109, name: "Рашаант" },
      { id: 2110, name: "Рэнчинлхүмбэ" },
      { id: 2111, name: "Тариалан" },
      { id: 2112, name: "Тосонцэнгэл" },
      { id: 2113, name: "Төмөрбулаг" },
      { id: 2114, name: "Түнэл" },
      { id: 2115, name: "Улаан-Уул" },
      { id: 2116, name: "Ханх" },
      { id: 2117, name: "Хатгал" },
      { id: 2118, name: "Цагааннуур" },
      { id: 2119, name: "Цагаан-Уул" },
      { id: 2120, name: "Цагаан-Үүр" },
      { id: 2121, name: "Цэцэрлэг" },
      { id: 2122, name: "Чандмань-Өндөр" },
      { id: 2123, name: "Шинэ-Идэр" },
      { id: 2124, name: "Эрдэнэбулган" },
    ],
  },
  {
    id: 22,
    name: "Хэнтий",
    code: "he",
    duureg: [
      { id: 2201, name: "Батноров" },
      { id: 2202, name: "Батширээт" },
      { id: 2203, name: "Баян-Адарга" },
      { id: 2204, name: "Баян-Овоо" },
      { id: 2205, name: "Баянмөнх" },
      { id: 2206, name: "Баянхутаг" },
      { id: 2207, name: "Биндэр" },
      { id: 2208, name: "Дадал" },
      { id: 2209, name: "Дархан" },
      { id: 2210, name: "Дэлгэрхаан" },
      { id: 2211, name: "Галшар" },
      { id: 2212, name: "Жаргалтхаан" },
      {
        id: 2213,
        name: "Хэрлэн",
        branch: "undurkhaan",
        code: "190612592457900000",
      },
      { id: 2214, name: "Мөрөн" },
      { id: 2215, name: "Норовлин" },
      { id: 2216, name: "Өмнөдэлгэр" },
      { id: 2217, name: "Цэнхэрмандал" },
    ],
  },
]

export const flashDeliveryDistrictList = [
  { name: "Баянгол", id: "bgd" },
  { name: "Баянзүрх", id: "bzd" },
  { name: "Сонгинохайрхан", id: "shd" },
  { name: "Сүхбаатар", id: "sbd" },
  { name: "Хан-Уул", id: "khud" },
  { name: "Чингэлтэй", id: "chd" },
  { name: "Налайх", id: "nd" },
]
export const pickupDistrictList = [
  { name: "Баянгол", id: "bgd" },
  { name: "Баянзүрх", id: "bzd" },
  { name: "Сонгинохайрхан", id: "shd" },
  { name: "Сүхбаатар", id: "sbd" },
  { name: "Хан-Уул", id: "khud" },
  { name: "Чингэлтэй", id: "chd" },
]
export const countryCodes = [
  { label: "Улаанбаатар", value: "UB" },
  { label: "Архангай", value: "AR" },
  { label: "Баян-Өлгий", value: "BO" },
  { label: "Баянхонгор", value: "BA" },
  { label: "Булган", value: "BU" },
  { label: "Говь-Алтай", value: "GA" },
  { label: "Говьсүмбэр", value: "GS" },
  { label: "Дархан-Уул", value: "DA" },
  { label: "Дорноговь", value: "DG" },
  { label: "Дорнод", value: "DO" },
  { label: "Дундговь", value: "DU" },
  { label: "Завхан", value: "ZA" },
  { label: "Орхон", value: "OR" },
  { label: "Өвөрхангай", value: "OV" },
  { label: "Өмнөговь", value: "OM" },
  { label: "Сүхбаатар", value: "SU" },
  { label: "Сэлэнгэ", value: "SE" },
  { label: "Төв", value: "TO" },
  { label: "Увс", value: "UV" },
  { label: "Ховд", value: "HO" },
  { label: "Хөвсгөл", value: "HU" },
  { label: "Хэнтий", value: "HE" },
]

export const nominSuperHyperBranches = [
  {
    name: "Түмэн Моол",
    address:
      "Баянзүрх дүүрэг, 25-р хороо, Түмэн молл худалдааны төв, 1давхарт Номин супермаркет",
    storeType: "Супермаркет",
    district: "Баянзүрх",
    subdistrict: "25-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/tumenmall.png",
  },
  {
    name: "Сэлбэ",
    address:
      "Баянзүрх дүүрэг, 1-р хороо, 12-р хороолол, Их тойруу, 91/1, 91/2 байр 1-р давхарт Номин Супермаркет",
    storeType: "Супермаркет",
    district: "Баянзүрх",
    subdistrict: "1-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/selbe.png",
    branch: "selbe",
  },
  {
    name: "Рапид хотхон",
    address: "Хан-Уул дүүрэг, 15-р хороо, Рапид Хурд хотхоны 4-р байр 1 тоот",
    storeType: "Супермаркет",
    district: "Хан-Уул",
    subdistrict: "15-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/rapid.png",
    branch: "rapid",
  },
  {
    name: "Ривер Гарден",
    address: "Хан-Уул дүүрэг, 11-р хороо, Ривер Гарден хотхон",
    storeType: "Супермаркет",
    district: "Хан-Уул",
    subdistrict: "11-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/river.png",
    branch: "rivergarden",
  },
  {
    name: "Нарны хороолол",
    address: "Баянгол дүүрэг, 3-р хороо, Нарны хороолол",
    storeType: "Супермаркет",
    district: "Баянгол",
    subdistrict: "3-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/narnihoroolol.png",
    branch: "narniikhoroolol",
  },
  {
    name: "ЭНЭШТ",
    address: "Баянгол дүүрэг, 15-р хороо, Билэг их дэлгүүр",
    storeType: "Супермаркет",
    district: "Баянгол",
    subdistrict: "15-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/enesht.png",
    branch: "bileg",
  },
  {
    name: "11-р хороолол",
    address: "Сүхбаатар дүүрэг, 7-р хороо, Эрхүүгийн гудамж, Этуаль төв",
    storeType: "Супермаркет",
    district: "Сүхбаатар",
    subdistrict: "7-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/11horoolol.png",
    branch: "arvannegkhoroolol",
  },
  {
    name: "Аз жаргал",
    address: "Сүхбаатар дүүрэг, 11-р хороо, Ногоон Нуурын гудамж, 301-р байр",
    storeType: "Супермаркет",
    district: "Сүхбаатар",
    subdistrict: "11-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/azjargal.png",
    branch: "azjargal",
  },
  {
    name: "Москва хороолол",
    address:
      "Сонгинохайрхан дүүрэг, 29-р хороо, Москва хороолол, 18070, Москвагийн гудамж , 125",
    storeType: "Супермаркет",
    district: "Сонгинохайрхан",
    subdistrict: "29-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/moskva.png",
    branch: "moskow",
  },
  {
    name: "Нарны гүүр",
    address: "Баянгол дүүрэг, 3-р хороо, Нарны гүүр,",
    storeType: "Супермаркет",
    district: "Баянгол",
    subdistrict: "3-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/narniguur.png",
    branch: "narniiguur",
  },
  {
    name: "Зунжин",
    address: "Чингэлтэй дүүрэг, 19-р хороо, Санзайн гудамж",
    storeType: "Супермаркет",
    district: "Чингэлтэй",
    subdistrict: "19-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/zunjin.png",
    branch: "zunjin",
  },
  {
    name: "Их Монгол",
    address: "Баянзүрх дүүрэг, 26-р хороо, Их Монгол Тауэр",
    storeType: "Супермаркет",
    district: "Баянзүрх",
    subdistrict: "26-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/ihmongol.png",
    branch: "ikhmongol",
  },
  {
    name: "7-н буудал",
    address: "Сүхбаатар дүүрэг, 14-р хороо, 7-н буудал, Бүрэн Плаза төв",
    storeType: "Супермаркет",
    district: "Сүхбаатар",
    subdistrict: "14-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/7buudal.png",
  },
  {
    name: "Жуков",
    address:
      "Баянзүрх дүүрэг, 14-р хороо, Энхтайвны өргөн чөлөө, Жуковын хөшөөний замын урд талд",
    storeType: "Супермаркет",
    district: "Баянзүрх",
    subdistrict: "14-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/jukov.png",
    branch: "jukow",
  },
  {
    name: "Өнөр плаза",
    address:
      "Сүхбаатар дүүрэг, 15-р хороо, 1-р хороолол, Өнөр плаза, 1-р давхар",
    storeType: "Супермаркет",
    district: "Сүхбаатар",
    subdistrict: "15-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/unurplaza.png",
    branch: "negkhoroolol",
  },
  {
    name: "Андууд",
    address: "Баянгол дүүрэг, 2-р хороо, Энхтайваны өргөн чөлөө, ТБД Андууд",
    storeType: "Супермаркет",
    district: "Баянгол",
    subdistrict: "2-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/anduud.png",
    branch: "anduud",
  },
  {
    name: "Зайсан",
    address:
      "Хан-Уул дүүрэг, 11-р хороо, White Hill Residence хотхон, 100/9 байр",
    storeType: "Супермаркет",
    district: "Хан-Уул",
    subdistrict: "11-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/zaisan.png",
    branch: "whitehill",
  },
  {
    name: "Зүүн 4 зам",
    address: "Баянзүрх дүүрэг, 4-р хороо, Зүүн 4 зам, Оршил хотхон",
    storeType: "Супермаркет",
    district: "Баянзүрх",
    subdistrict: "4-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/zuun4zam.png",
    branch: "zuunduruv",
  },
  {
    name: "Улсын Их Дэлгүүр",
    address:
      "Чингэлтэй дүүрэг, 3-р хороо, Энхтайваны өргөн чөлөө, УИД ХК-ийн байр",
    storeType: "Хайпермаркет",
    district: "Чингэлтэй",
    subdistrict: "3-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/uid.png",
    branch: "hm-uid",
  },
  {
    name: "Номин Плаза Их Дэлгүүр",
    address: "Баянгол дүүрэг, 14-р хороо, Ард Аюушийн өргөн чөлөө,",
    storeType: "Хайпермаркет",
    district: "Баянгол",
    subdistrict: "14-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/nid.png",
    branch: "plaza",
  },
  {
    name: "Номин Юнайтед",
    address: "Хан-Уул дүүрэг, 20-р хороо, Чингисийн өргөн чөлөө, Номин Юнайтед",
    storeType: "Хайпермаркет",
    district: "Хан-Уул",
    subdistrict: "20-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/united.png",
    branch: "united",
  },
  {
    name: "УБИ Хайпер",
    address:
      "Сонгинохайрхан дүүрэг, 20-р хороо, Орбитын гудамж, Улаанбаатар Импекс",
    storeType: "Хайпермаркет",
    district: "Сонгинохайрхан",
    subdistrict: "20-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/ubi.png",
    branch: "ubi",
  },
  {
    name: "Наадам",
    address: "Хан-Уул дүүрэг, 15-р хороо, Махатма Гандийн гудамж, Наадам Цэнтр",
    storeType: "Хайпермаркет",
    district: "Хан-Уул",
    subdistrict: "15-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/naadam.png",
    branch: "naadam",
  },
  {
    name: "32-н Хайпер",
    address: "Сүхбаатар дүүрэг, 12-р хороо, 32-ын тойрог",
    storeType: "Хайпермаркет",
    district: "Сүхбаатар",
    subdistrict: "12-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/32.png",
    branch: "guchin",
  },
  {
    name: "Өнөр хотхон",
    address: "Баянгол дүүрэг, 20-р хороо, Москвагийн гудамж, Өнөр хороолол",
    storeType: "Хайпермаркет",
    district: "Баянгол",
    subdistrict: "20-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/unurhothon.png",
    branch: "unur",
  },
  {
    name: "Скайтаун",
    address: "Баянзүрх дүүрэг, 13-хороо, Энхтайваны өргөн чөлөө, 89-р байр",
    storeType: "Хайпермаркет",
    district: "Баянзүрх",
    subdistrict: "13-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/skytown.png",
    branch: "skytown",
  },
  {
    name: "13-н Хайпермаркет",
    address: "Баянзүрх дүүрэг, 14-р хороо, Намьянжүгийн гудамж",
    storeType: "Хайпермаркет",
    district: "Баянзүрх",
    subdistrict: "14-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/13.png",
    branch: "allmart",
  },
  {
    name: "Яармаг 1-р уулзвар",
    address: "Хан-Уул дүүрэг, 4-р хороо, Будда Гүрү Ренбүүчи Манастира",
    storeType: "Хайпермаркет",
    district: "Хан-Уул",
    subdistrict: "4-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/yarmag.png",
    branch: "yarmag",
  },
  {
    name: "Седар",
    address: "Хан-Уул дүүрэг, 4-р хороо, Арцадын ам, Наадамчдын зам 1633",
    storeType: "Хайпермаркет",
    district: "Хан-Уул",
    subdistrict: "4-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/sedar.png",
    branch: "sedar",
  },
  {
    name: "Буянт-Ухаа",
    address:
      "Хан-Уул дүүрэг, 16-р хороо, Буянт-ухаа хороолол, Наадамчдын зам, Хан Плаза төвийн байр, 1-р давхар, 103 тоот",
    storeType: "Хайпермаркет",
    district: "Хан-Уул",
    subdistrict: "16-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/niseh.png",
    branch: "niseh",
  },
  {
    name: "10-р хороолол",
    address: "Баянгол дүүрэг, 5-р хороо, 10-р хороолол, Хасбат худалдааны төв",
    storeType: "Хайпермаркет",
    district: "Баянгол",
    subdistrict: "5-р хороо",
    image: "https://assets.nomin.mn/web/branch-images/10horoolol.png",
    branch: "aravhoroolol",
  },
]

export const locations = [
  {
    name: "УИД ХМ",
    plusCode: "WW84+PG",
    addressText:
      "Чингэлтэй дүүрэг, 3-р хороо, Энхтайваны өргөн чөлөө УИД ХК-ын байр",
    fastFood: "Pizza Hut, милая",
    internationalFood: "Ази хоол",
    coffee: "Cafe bene, Restime, Pascucci",
    selfCheckout: "Байгаа",
    cando: "Байгаа",
    bakery: "Gute bakery, жүр үр, ту лэ жүр, мон бэйкэри, wendy",
    type: "Хайпермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.91681249999998,
    longitude: 106.90631250000001,
    district: "Чингэлтэй",
    image: "https://assets.nomin.mn/web/nomin-branches/uid1.webp",
  },
  {
    name: "Зунжин",
    plusCode: "2W3F+JVR",
    addressText: "Чингэлтэй дүүрэг, 19-р хороо, Санзайн гудамж",
    fastFood: "PIZZA",
    motorcycle: "wonderer, keeway",
    pharmacy: "Монгол эм импэкс концерк",
    bakery: "Батбайгаль бэйкери",
    atm: "Хаан банк ,Голомт банк",
    glasses: "Сор мэлмий",
    type: "Супермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 48.00406249999999,
    longitude: 106.92468749999995,
    district: "Чингэлтэй",
    image: "https://assets.nomin.mn/web/nomin-branches/zunjin.webp",
  },
  {
    name: "22-товчоо",
    plusCode: "WP3Q+35C",
    addressText: "Сонгинохайрхан дүүрэг, 20-р хороо, Tөмөр зам задгай-60",
    fastFood: "Pizza hut",
    internationalFood: "Олон үндэстний хоол",
    motorcycle: "wonderer, keeway",
    pharmacy: "Агар фарм",
    bakery: "Батбайгаль бэйкери",
    type: "Агуулах худалдаа",
    timetable: "Даваа-Баасан 08:45-22:00, Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.9026875,
    longitude: 106.73793750000004,
    district: "Сонгинохайрхан",
    image: "https://assets.nomin.mn/web/nomin-branches/22.webp",
  },
  {
    name: "Их Монгол",
    plusCode: "WW4V+25X",
    addressText: "Баянзүрх дүүрэг, 26-р хороо, Их Монгол Тауэр",
    bakery: "монбейкери",
    type: "Супермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.9050625,
    longitude: 106.94293750000003,
    district: "Баянзүрх",
    image: "https://assets.nomin.mn/web/nomin-branches/ikhmongol1.webp",
  },
  {
    name: "Билэг",
    plusCode: "WVFQ+GG",
    addressText: "Баянгол дүүрэг, 15-р хороо, Билэг их дэлгүүр",
    flower: "Очмаа амьд цэцэг",
    internationalFood: "Милая түргэнэ хоол бэйкэри",
    phoneAccessory: "Цолмон гар утасны дагалдах",
    atm: "Хаан банк, Төрийн банк, Голомт",
    type: "Супермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.92375000000001,
    longitude: 106.88875000000004,
    district: "Баянгол",
    image: "https://assets.nomin.mn/web/nomin-branches/bileg1.webp",
  },
  {
    name: "Седар",
    plusCode: "VR9G+PFJ",
    addressText: "Хан-Уул дүүрэг, 4-р хороо, Арцадын ам, Наадамчдын зам 1633",
    flower: "Оюу flowers, Дэлбээ",
    plant: "Байгаа",
    unet: "Байгаа",
    internationalFood: "Аз фүүд корт",
    coffee: "Segafredo",
    motorcycle: "Байгаа",
    selfCheckout: "Байгаа",
    insurance: "Байгаа",
    cando: "Байгаа",
    pharmacy: "Монос",
    gooSaihan: "Mild cosmetics, Natures republic, номин косметикс",
    bakery: "Турк бэйкэри",
    atm: "Голомт банк",
    glasses: "Байгаа",
    type: "Хайпермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.86931249999999,
    longitude: 106.8261875,
    district: "Хан-Уул",
    image: "https://assets.nomin.mn/web/nomin-branches/sedar.webp",
  },
  {
    name: "Эрдэнэт СМ",
    plusCode: "22GR+M9J",
    addressText: "Орхон аймаг, Баян Өндөр сум, Бүрэнбүст баг",
    flower: "Цэцгийн түрээс",
    atm: "Хаан.Голомт",
    type: "Орон нутаг СМ",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 49.026688,
    longitude: 104.040937,
    district: "Орхон",
    image: "https://assets.nomin.mn/web/nomin-branches/erdenet1.webp",
  },
  {
    name: "Зуунмод",
    plusCode: "PW2W+X3",
    addressText:
      "Төв аймаг, Зуунмод сум, Төв Зуунмод, Номт, 1-р баг, Манзушир өргөө хороолол, 1-р байр",
    flower: "Цэцэг бэлэг дурсгал Байгаа",
    fastFood: "Food court",
    pharmacy: "Монос эмийн сан",
    phoneAccessory: "Гар утас дагалдах хэрэгсэл Байгаа",
    gooSaihan: "Queen bee үсчин түрээс",
    bakery: "B&B Bakarey",
    atm: "Хаан банк",
    glasses: "Гоёл чимэглэл",
    type: "Орон нутаг СМ",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.70243749999999,
    longitude: 106.94518750000003,
    district: "Төв",
    image: "https://assets.nomin.mn/web/nomin-branches/zuunmod1.webp",
  },
  {
    name: "Дархан Зүүн урд",
    plusCode: "FX69+QX7",
    addressText: "Дархан аймаг, Дархан сум, 16-р баг",
    flower: "Цэцэг худалдаа",
    plant: "Бэлэг дурсгал",
    unet: "ҮНЭТ ЭДЛЭЛ",
    hivs: "Эрдэнэт хивс",
    internationalFood: "Олон үндэстний хоол",
    restaurant: "Шөлөндөө",
    motorcycle: "wonderer, keeway",
    lotte: "LOTTE MART",
    insurance: "Номин даатгал",
    bank: "Ариг банк",
    terranova: "Terranova Calliope Outlet",
    cando: "cando",
    pharmacy: "Монос фарм",
    atm: "АТМ /Хаан, Голомт /",
    himiTseverlegee: "Хими цэвэрлэгээ",
    type: "Орон нутаг АХ",
    timetable: "Даваа-Баасан 09:00-22:00, Бямба 09:00-22:00, Ням 09:00-21:30",
    latitude: 49.461938,
    longitude: 105.969938,
    district: "Дархан",
    image: "https://assets.nomin.mn/web/nomin-branches/darkhan.webp",
  },
  {
    name: "Наадам центр",
    plusCode: "WW36+4M9",
    addressText: "Хан-Уул дүүрэг, 15-р хороо, Махатма Ганди гудамж Г-201",
    flower: "Оюу flowers, цэцэгт мэндчилгээ",
    plant: "Байгаа",
    unet: "Байгаа",
    fastFood: "милая",
    internationalFood: "Олон үндэстний хоол",
    restaurant: "Солонгос ресторан",
    coffee: "Cafe bene",
    selfCheckout: "Байгаа",
    insurance: "киоск Байгаа",
    terranova: "Terranova, Calliope",
    cando: "Байгаа",
    pharmacy: "Монфарм",
    gooSaihan: "Mild cosmetics, Focculare, Green gate",
    bakery: "Ту лэ жүр, милая",
    atm: "Хаан, Голомт",
    himiTseverlegee: "Тунамал хими цэвэрлэгээ",
    type: "Хайпермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.902812499999996,
    longitude: 106.91168749999997,
    district: "Хан-Уул",
    image: "https://assets.nomin.mn/web/nomin-branches/naadam1.webp",
  },
  {
    name: "Нарны гүүр",
    plusCode: "WV4W+M4",
    addressText: "Баянгол дүүрэг, 26-р хороо, Нарны гүүр",
    pharmacy: "Агар фарм",
    bakery: "Gute-бэйкери",
    atm: "Хаан банк",
    type: "Супермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.90668749999999,
    longitude: 106.89531250000005,
    district: "Баянгол",
    image: "https://assets.nomin.mn/web/nomin-branches/narniiguur.webp",
  },
  {
    name: "Өвөрхангай",
    plusCode: "7Q6Q+7PP",
    addressText:
      "Өвөрхангай аймаг, Арвайхээр сум, 13 дугаар баг 5р гудамж 506 тоот",
    internationalFood: "Олон үндэстний хоол",
    motorcycle: "wonderer, keeway",
    pharmacy: "Монос фарм",
    atm: "Хаан АТМ",
    type: "Орон нутаг АХ",
    timetable: "Даваа-Баасан 09:00-22:00, Бямба 09:00-22:00, Ням 09:00-21:30",
    latitude: 46.260687,
    longitude: 102.789312,
    district: "Өвөрхангай",
    image: "https://assets.nomin.mn/web/nomin-branches/arvaiheer1.webp",
  },
  {
    name: "Замын-үүд",
    plusCode: "PW82+7RF",
    addressText:
      "Дорноговь аймаг, Замын-Үүд сум, 1-р баг, 7 дугаар хэсэг, 149-р байр, 5-н 29 тоот",
    internationalFood: "Олон үндэстний хоол",
    motorcycle: "wonderer, keeway",
    phoneAccessory: "Гар утас, дагалдах хэрэгсэл",
    atm: "Хаан АТМ",
    type: "Орон нутаг АХ",
    timetable: "Даваа-Баасан 09:00-22:00, Бямба 09:00-22:00, Ням 09:00-21:30",
    latitude: 43.716051708931914,
    longitude: 111.90213183069056,
    district: "Дорноговь",
    image: "https://assets.nomin.mn/web/nomin-branches/zamiinuud1.webp",
  },
  {
    name: "Сэлбэ",
    plusCode: "WWHJ+MXQ",
    addressText:
      "Баянзүрх дүүрэг, 1-р хороо, 12-р хороолол, Их тойруу, 91/1, 91/2 байр 1-р давхарт",
    flower: "Цэцэг",
    bakery: "Тэнгэрийн хишиг бейкери",
    type: "Супермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.9291875,
    longitude: 106.93243749999993,
    district: "Баянзүрх",
    image: "https://assets.nomin.mn/web/nomin-branches/selbe1.webp",
  },
  {
    name: "Багануур",
    plusCode: "Q9H9+2W",
    addressText: "Багануур дүүрэг, 3-р хороо, Наран хороолол, Нацагдоржын 75",
    flower: "Цэцэг бэлэг дурсгал Байгаа",
    motorcycle: "wonderer",
    pharmacy: "Сити фарм",
    gooSaihan: "Гоо сайхан түрээс Байгаа",
    atm: "Хаан банк, Төрийн банк",
    type: "Орон нутаг СМ",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.777563,
    longitude: 108.369812,
    district: "Багануур",
    image: "https://assets.nomin.mn/web/nomin-branches/baganuur1.webp",
  },
  {
    name: "32-н тойрог",
    addressText:
      "Сүхбаатар дүүрэг, 12-р хороо, Чингэлтэйн өргөн чөлөө гудамж 7 тоот",
    fastFood: "Pizza Hut",
    plusCode: "WWR8+F5",
    insurance: "Байгаа",
    cando: "Байгаа",
    pharmacy: "Мөнхийн тун",
    atm: "Хаан",
    type: "Хайпермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.9411875,
    longitude: 106.9154375,
    district: "Сүхбаатар",
    image: "https://assets.nomin.mn/web/nomin-branches/321.webp",
  },
  {
    name: "Плаза ХМ",
    plusCode: "WVFG+6G",
    addressText:
      "Баянгол дүүрэг, 14-р хороо, 4-р хороолол Энэбишийн өргөн чөлөө 15/2 тоот",
    flower: "Оюу flowers, Flora, Жарден",
    plant: "Байгаа",
    fastFood: "Милая",
    internationalFood: "Chicken",
    selfCheckout: "Байгаа",
    bakery: "Мон бэйкэри, милая",
    atm: "Хаан, Төрийн банк, Голомт, Хас,",
    type: "Хайпермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.9230625,
    longitude: 106.87631250000004,
    district: "Баянгол",
    image: "https://assets.nomin.mn/web/nomin-branches/nid1.webp",
  },
  {
    name: "10-р хороолол",
    plusCode: "WV78+RH",
    addressText:
      "Баянгол дүүрэг, 5-р хороо, 10-р хороолол, Энхтайваны өргөн чөлөө гудамж 83/6 тоот",
    flower: "Flora цэцэг",
    coffee: "Artisan Espreso",
    selfCheckout: "Байгаа",
    cando: "Байгаа",
    pharmacy: "Агар",
    phoneAccessory: "Байгаа",
    manicure: "Байгаа",
    bakery: "Gute bakery",
    atm: "Төрийн банк, Голомт, Хаан",
    glasses: "Байгаа",
    type: "Хайпермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.9145625,
    longitude: 106.86643750000002,
    district: "Баянгол",
    image: "https://assets.nomin.mn/web/nomin-branches/10.webp",
  },
  {
    name: "Хан-Уул",
    plusCode: "VWX2+9G",
    addressText:
      "Хан-Уул дүүрэг, 20-р хороо, Чингисийн өргөн чөлөө, УБ Хивс ХК",
    flower: "Delweiss гоёл чимэглэл",
    plant: "Дэлбээ амьд цэцэг,Florish амьд цэцэг",
    fastFood: "Mum's touch,K-Delica пицца",
    coffee: "Cafe Bene",
    motorcycle: "wonderer, keeway",
    lotte: "LOTTE MART",
    pharmacy: "Health point эмийн сан",
    gooSaihan: "Mild косметикс,The face shop косметикс,Хангүг косметикс",
    bakery: "Gute бейкери",
    glasses: "Үүрийн гэгээ оптек нүдний шил",
    type: "Агуулах худалдаа",
    timetable: "Даваа-Баасан 08:45-22:00, Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.898438,
    longitude: 106.901313,
    district: "Хан-Уул",
    image: "https://assets.nomin.mn/web/nomin-branches/khanuul1.webp",
  },
  {
    name: "Зүүн 4 зам",
    plusCode: "WW9V+MX",
    addressText: "Баянзүрх дүүрэг, 4-р хороо, Зүүн 4 зам, Оршил хотхон",
    flower: "Хишигжаргал Амьд цэцэг",
    internationalFood: "Солонгос хоол Шинсай ХХК",
    coffee: "Бейнди бейкири",
    pharmacy: "Сити фарм",
    gooSaihan: "Ayras beaty",
    bakery: "Бенди бэйкири",
    shoeGooSaihan: "Shoes love",
    type: "Супермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.91918750000001,
    longitude: 106.94493749999998,
    district: "Баянзүрх",
    image: "https://assets.nomin.mn/web/nomin-branches/zuun41.webp",
  },
  {
    name: "Баянхошуу",
    plusCode: "XR5G+4G9",
    addressText: "Сонгинохайрхан дүүрэг, 9-р хороо, Малчины 1-1",
    fastFood: "KFC",
    motorcycle: "wonderer, keeway",
    lotte: "LOTTE MART",
    pharmacy: "Арвижих даац эмийн сан",
    phoneAccessory: "Гар утасны дэлгэцний наалт",
    bakery: "Батбайгаль бейкери",
    atm: "Хаан, Голомт АТМ",
    glasses: "Нүдний шил",
    type: "Агуулах худалдаа",
    timetable: "Даваа-Баасан 08:45-22:00, Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.957812499999974,
    longitude: 106.82631250000003,
    district: "Сонгинохайрхан",
    image: "https://assets.nomin.mn/web/nomin-branches/bayanhoshuu1.webp",
  },
  {
    name: "НИД",
    addressText: "Баянгол дүүрэг, 14-р хороо, Ард Аюушийн өргөн чөлөө",
    plusCode: "WVFG+6G",
    fastFood: "Lotteria",
    coffee: "Cafe bene",
    type: "Их дэлгүүр",
    timetable: "Даваа-Бямба 09:00-22:00, Ням 09:00-21:30",
    latitude: 47.9230625,
    longitude: 106.87631250000004,
    district: "Баянгол",
    image: "https://assets.nomin.mn/web/nomin-branches/nid1.webp",
  },
  {
    name: "Хөвсгөл",
    plusCode: "J5P8+WC",
    addressText: "Хөвсгөл аймаг, Мөрөн сум, 6-р баг, 1-1 тоот",
    flower: "Мөнгөн гоёл",
    fastFood: "Pizza",
    internationalFood: "Олон үндэстний хоол",
    coffee: "Yummy кофе шоп",
    motorcycle: "wonderer, keeway",
    pharmacy: "Монос фарм",
    phoneAccessory: "Гар утас, дагалдах хэрэгсэл",
    atm: "Төр, Хаан, Голомт АТМ",
    type: "Орон нутаг АХ",
    timetable: "Даваа-Баасан 09:00-22:00, Бямба 09:00-22:00, Ням 09:00-21:30",
    latitude: 49.637313,
    longitude: 100.166062,
    district: "Хөвсгөл",
    image: "https://assets.nomin.mn/web/nomin-branches/murun.webp",
  },
  {
    name: "Дархан Хойд",
    plusCode: "FWMR+329",
    addressText: "Дархан, Дархан сум, 16-р баг",
    fastFood: "Burger king",
    internationalFood: "Олон үндэстний хоол",
    restaurant: "Милая",
    motorcycle: "wonderer, keeway",
    lotte: "LOTTE MART",
    pharmacy: "Монос фарм",
    gooSaihan: "Face shop",
    atm: "Голомт, ХХБ АТМ",
    type: "Орон нутаг АХ",
    timetable: "Даваа-Баасан 09:00-22:00, Бямба 09:00-22:00, Ням 09:00-21:30",
    latitude: 49.482687,
    longitude: 105.940062,
    district: "Дархан",
    image: "https://assets.nomin.mn/web/nomin-branches/darkhan.webp",
  },
  {
    name: "Баянзүрх АХ",
    plusCode: "V3JV+GG5",
    addressText: "Баянзүрх дүүрэг, 11-р хороо, Хөлийн гол, 1-р гудамж, 27 тоот",
    unet: "Гоёл чимэглэл",
    internationalFood: "Олон үндэстний хоол",
    coffee: "Restime кофе шоп",
    motorcycle: "wonderer, keeway",
    lotte: "LOTTE MART",
    pharmacy: "Жен фарм эмийн сан",
    phoneAccessory: "Гар утасны дэлгэцний наалт",
    type: "Агуулах худалдаа",
    timetable: "Даваа-Баасан 08:45-22:00, Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.88131249999999,
    longitude: 107.09381250000007,
    district: "Баянзүрх",
    image: "https://assets.nomin.mn/web/nomin-branches/baynzurh.webp",
  },
  {
    name: "Өмнөговь",
    plusCode: "HCGP+H4V",
    addressText: "Өмнөговь, Даланзадгад сум, 3-р баг",
    internationalFood: "Олон үндэстний хоол",
    coffee: "On on coffe shop",
    motorcycle: "wonderer, keeway",
    pharmacy: "MEIC фарм",
    bakery: "On on bakery",
    atm: "АТМ",
    selfWashing: "City laundry",
    type: "Орон нутаг АХ",
    timetable: "Даваа-Баасан 09:00-22:00, Бямба 09:00-22:00, Ням 09:00-21:30",
    latitude: 43.574813,
    longitude: 104.436813,
    district: "Өмнөговь",
    image: "https://assets.nomin.mn/web/nomin-branches/dalanzadgad.webp",
  },
  {
    name: "Рапид",
    plusCode: "WW44+75W",
    addressText:
      "Хан-Уул дүүрэг, 15-р хороо, Рапид Хурд хотхоны 4-р байр 1 тоот",
    flower: "Цогмаа-Цэцэг",
    bakery: "Талх чихэр",
    type: "Супермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.901438,
    longitude: 106.918937,
    district: "Хан-Уул",
    image: "https://assets.nomin.mn/web/nomin-branches/rapid.webp",
  },
  {
    name: "Юнайтед",
    plusCode: "VVWQ+MJF",
    addressText:
      "Хан-Уул дүүрэг, 20-р хороо, Чингисийн өргөн чөлөө Гутал ХХК-ын байр",
    flower: "Байгаа",
    plant: "Байгаа",
    hivs: "Байгаа",
    fastFood: "Милая",
    internationalFood: "Олон үндэстний хоол",
    restaurant: "YUNA, RED PANDA",
    coffee: "Pascucci",
    selfCheckout: "Байгаа",
    insurance: "Байгаа",
    bank: "Ариг, Голомт",
    cando: "Байгаа",
    laboratory: "Эко стандарт Лаборатори",
    pharmacy: "Мөнхийн тун",
    phoneAccessory: "Байгаа",
    manicure: "SB beauty salon",
    bakery: "Gute bakery",
    atm: "Голомт, Хас",
    glasses: "Байгаа",
    type: "Хайпермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.89668749999997,
    longitude: 106.88906250000008,
    district: "Хан-Уул",
    image: "https://assets.nomin.mn/web/nomin-branches/united.webp",
  },
  {
    name: "Өнөр хороолол",
    addressText:
      "Баянгол дүүрэг, 29-р хороо, Москва гудамж 39-р байр Өнөр хотхон өөрийн байранд",
    plusCode: "WVFQ+GG",
    flower: "Flora цэцэг",
    hivs: "Байгаа",
    fastFood: "Pizza hut",
    insurance: "Байгаа",
    cando: "Байгаа",
    pharmacy: "Монос",
    gooSaihan:
      "Mild cosmetics, kangoroo mom, Face shop, Focculare, Номин Косметикс",
    manicure: "Zulaa nail art",
    bakery: "Gute bakery",
    atm: "Голомт, Хаан, Хас, Төрийн банк",
    glasses: "Байгаа",
    shoeGooSaihan: "shoes love",
    himiTseverlegee: "shoes love",
    type: "Хайпермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.911812,
    longitude: 106.846563,
    district: "Баянгол",
    image: "https://assets.nomin.mn/web/nomin-branches/unurhm.webp",
  },
  {
    name: "Дундговь",
    plusCode: "Q78H+FH",
    addressText: "Дундговь аймаг, Сайнцагаан сум, 7-р баг, Нарлаг 8",
    flower: "Бэлэг дурсгал",
    internationalFood: "Олон үндэстний хоол",
    motorcycle: "wonderer, keeway",
    pharmacy: "Тавин ус эмийн сан",
    phoneAccessory: "Гар утас дагалдах хэрэгсэл",
    gooSaihan: "Beuaty japan",
    atm: "Хаан АТМ",
    type: "Орон нутаг АХ",
    timetable: "Даваа-Баасан 09:00-22:00, Бямба 09:00-22:00, Ням 09:00-21:30",
    latitude: 45.766188,
    longitude: 106.278937,
    district: "Дундговь",
    image: "https://assets.nomin.mn/web/nomin-branches/mandalgovi.webp",
  },
  {
    name: "Ривер гарден",
    plusCode: "VWQM+W5",
    addressText: "Хан-Уул дүүрэг, 11-р дүүрэг, Ривер Гарден хотхон",
    restaurant: "Милая",
    type: "Супермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.88981249999999,
    longitude: 106.93293750000004,
    district: "Хан-Уул",
    image: "https://assets.nomin.mn/web/nomin-branches/river.webp",
  },
  {
    name: "Түмэн",
    plusCode: "WW5R+9X9",
    addressText:
      "Баянзүрх дүүрэг, 25-р хороо, Түмэн молл худалдааны төв, 1давхарт",
    flower: "Жасмин цэцэг",
    fastFood: "милая",
    bakery: "Атархишиг бейкери",
    type: "Супермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.908437500000005,
    longitude: 106.94243749999998,
    district: "Баянзүрх",
    image: "https://assets.nomin.mn/web/nomin-branches/tumenmall.webp",
  },
  {
    name: "Жуков",
    plusCode: "WX83+MQC",
    addressText:
      "Баянзүрх дүүрэг, Энхтайвны өргөн чөлөө, 14-р хороо, Жуковын хөшөөний замын урд талд",
    flower: "Zaya Premium Flower",
    fastFood: "Мөнө",
    atm: "Худалдаа хөгжлийн банк. Хаан банк",
    himiTseverlegee: "Grass цэвэрлэгээний бүтээгдэхүүн. хими цэвэрлэгээ",
    type: "Супермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.91668749999998,
    longitude: 106.95443749999998,
    district: "Баянзүрх",
    image: "https://assets.nomin.mn/web/nomin-branches/jukow.webp",
  },
  {
    name: "Аз жаргал хотхон",
    plusCode: "WWMC+CC",
    addressText:
      "Cүхбаатар дүүрэг, 11-р хороо Ногоон Нуурын гудамж, 301-р байр",
    flower: "Zaya Premium Flower",
    fastFood: "Милая фүүдс",
    pharmacy: "СИТИ Фрам",
    bakery: "Венди бейкери",
    atm: "ХААН,ХАС,ХХБ",
    type: "Супермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.93356250000001,
    longitude: 106.92106249999995,
    district: "Cүхбаатар",
    image: "https://assets.nomin.mn/web/nomin-branches/azjargal.webp",
  },
  {
    name: "Увс",
    plusCode: "X3MH+3R",
    addressText: "Увс аймаг, Улаангом хот, 12-р баг",
    flower: "Гоёл чимэглэл",
    fastFood: "Pizza",
    internationalFood: "Олон үндэстний хоол",
    motorcycle: "wonderer, keeway",
    gooSaihan: "Гоо сайхан",
    bakery: "Өнхрүүш бэйкери",
    atm: "АТМ",
    type: "Орон нутаг АХ",
    timetable: "Даваа-Баасан 09:00-22:00, Бямба 09:00-22:00, Ням 09:00-21:30",
    latitude: 49.98338548646881,
    longitude: 92.07935542327358,
    district: "Увс",
    image: "https://assets.nomin.mn/web/nomin-branches/ulaangom.webp",
  },
  {
    name: "Макро АХ",
    plusCode: "VR85+4FC",
    addressText: "Хан -Уул дүүрэг, 6-р хороо, Наадамчдын зам",
    plant: "Nandin цэцэг",
    fastFood: "Pelati",
    internationalFood: "Mandu house, Red panda, Yoshinoya",
    coffee: "Mega coffee, Pascucci, Segafredo",
    motorcycle: "Benelli,wonderer, keeway, kawasaki",
    lotte: "LOTTE MART",
    pharmacy: "Эмийн сан",
    gooSaihan: "Гоо сайхан",
    glasses: "Нүдний шил",
    selfWashing: "City laundry",
    type: "Агуулах худалдаа",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.86531249999997,
    longitude: 106.80868750000002,
    district: "Хан-Уул",
    image: "https://assets.nomin.mn/web/nomin-branches/macro.webp",
  },
  {
    name: "Дорнод",
    plusCode: "3GJR+HR",
    addressText:
      "Дорнод аймаг, Хэрлэн сум, 11-р баг , партизан Содномдаржаагийн гудамж",
    flower: "Цэцэг бэлэг дурсгал",
    internationalFood: "Олон үндэстний хоол",
    coffee: "Кофе шоп",
    motorcycle: "wonderer, keeway",
    pharmacy: "Монос фарм",
    phoneAccessory: "Гар утас, дагалдах хэрэгсэл",
    gooSaihan: "Гоо сайхан",
    bakery: "Жүр үр",
    atm: "Хаан, Хас, Голомт АТМ",
    type: "Орон нутаг АХ",
    timetable: "Даваа-Баасан 09:00-22:00, Бямба 09:00-22:00, Ням 09:00-21:30",
    latitude: 48.08201841485881,
    longitude: 114.54191233861887,
    district: "Дорнод",
    image: "https://assets.nomin.mn/web/nomin-branches/herlen.webp",
  },
  {
    name: "Сүхбаатар",
    plusCode: "M7MJ+8J6",
    addressText: "Сүхбаатар аймаг, Баруун-Урт сум, 7-р баг",
    internationalFood: "Олон үндэстний хоол",
    coffee: "Кофе шоп",
    motorcycle: "wonderer, keeway",
    phoneAccessory: "Гар утас",
    atm: "АТМ",
    glasses: "Нүдний шил",
    type: "Орон нутаг АХ",
    timetable: "Даваа-Баасан 09:00-22:00, Бямба 09:00-22:00, Ням 09:00-21:30",
    latitude: 46.683312,
    longitude: 113.281563,
    district: "Сүхбаатар",
    image: "https://assets.nomin.mn/web/nomin-branches/baruunurt.webp",
  },
  {
    name: "УБИ ХМ",
    plusCode: "WQ5W+XW6",
    addressText:
      "Сонгинохайрхан дүүрэг, 20-р хороо, Орбитын гудамж, Толгойт Хүнсчдийн гудамж, 60/3 тоот",
    flower: "Байгаа",
    plant: "Байгаа",
    fastFood: "PIZZA",
    internationalFood: "Олон үндэстний хоол",
    insurance: "Байгаа",
    cando: "Байгаа",
    pharmacy: "Монос",
    glasses: "Байгаа",
    type: "Хайпермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.9099375,
    longitude: 106.79731250000003,
    district: "Сонгинохайрхан",
    image: "https://assets.nomin.mn/web/nomin-branches/ubihm.webp",
  },
  {
    name: "Нарны хороолол",
    plusCode: "WV4W+M4",
    addressText: "Баянгол дүүрэг, 3-р дүүрэг, Нарны хороолол",
    flower: "мөнхзул амьд цэцэг",
    type: "Супермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.90668749999999,
    longitude: 106.89531250000005,
    district: "Баянгол",
    image: "https://assets.nomin.mn/web/nomin-branches/narniihoroolol.webp",
  },
  {
    name: "11-р хороолол",
    plusCode: "WWHG+2RP",
    addressText: "Сүхбаатар дүүрэг, 7-р хороо, Эрхүүгийн гудамж, Этуаль төв",
    flower: "Uran Flowers",
    bakery: "Батбайгаль бэйкери",
    atm: "Хаан банк ,Голомт банк",
    type: "Супермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.92756250000001,
    longitude: 106.92706249999998,
    district: "Сүхбаатар",
    image: "https://assets.nomin.mn/web/nomin-branches/11.webp",
  },
  {
    name: "Яармаг",
    plusCode: "VRFQ+J6",
    addressText:
      "Хан-Уул дүүрэг, 4-р хороо, Яармаг /17110/ Наадамчдын зам гудамж 762 тоот,",
    flower: "Оюу flowers, Flora",
    plant: "Байгаа",
    fastFood: "Pizza Hut, KFC",
    internationalFood: "Олон үндэстний хоол",
    restaurant: "MR Ling",
    coffee: "Segafredo",
    selfCheckout: "Байгаа",
    cando: "Байгаа",
    pharmacy: "Ситифарм",
    manicure: "Байгаа",
    bakery: "Gute bakery",
    gameCenter: "Тоглоомын төв",
    atm: "Хаан, Төрийн банк",
    glasses: "Байгаа",
    himiTseverlegee: "Тунамал хими цэвэрлэгээ",
    type: "Хайпермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.874062499999994,
    longitude: 106.83806250000004,
    district: "Хан-Уул",
    image: "https://assets.nomin.mn/web/nomin-branches/yarmag.webp",
  },
  {
    name: "13-р хороолол",
    plusCode: "WW7V+JMM",
    addressText:
      "Баянзүрх дүүрэг, 14-р хороо, 11-р хороолол, Намьянжүгийн гудамж 25 тоот",
    flower: "Байгаа",
    plant: "Байгаа",
    fastFood: "Pizza Hut",
    internationalFood: "Олон үндэстний хоол",
    terranova: "Terranova",
    cando: "Байгаа",
    pharmacy: "Төгөлдөр жаргалант",
    phoneAccessory: "Байгаа",
    gooSaihan: "Mild cosmetics, Face shop",
    atm: "Голомт, Хаан, Төрийн банк",
    glasses: "Байгаа",
    type: "Хайпермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.914062499999986,
    longitude: 106.9441875,
    district: "Баянзүрх",
    image: "https://assets.nomin.mn/web/nomin-branches/13.webp",
  },
  {
    name: "Эрдэнэт",
    plusCode: "23JH+RJ",
    addressText: "Эрдэнэт Хот, Баян-Өндөр сум, Баянцагаан баг, 2а миркорайон",
    flower: "Цэцэг бэлэг дурсгал",
    internationalFood: "Олон үндэстний хоол",
    coffee: "Кофе шоп",
    motorcycle: "wonderer, keeway",
    phoneAccessory: "Гар утас, дагалдах хэрэгсэл",
    gooSaihan: "Гоо сайхан",
    atm: "Хаан, Голомт АТМ",
    type: "Орон нутаг АХ",
    timetable: "Даваа-Баасан 09:00-22:00, Бямба 09:00-22:00, Ням 09:00-21:30",
    latitude: 49.0326103922314,
    longitude: 104.07906608465471,
    district: "Эрдэнэт",
    image: "https://assets.nomin.mn/web/nomin-branches/erdenetah.webp",
  },
  {
    name: "Цагаан хаалга",
    plusCode: "VQ5P+M5",
    addressText:
      "Хан-Уул дүүрэг, 16-р хороо, Буянт -Ухаа хороолол, /17120/ Наадамчдын зам гудамж, 103 тоот, Хан Плазагийн төвийн байр, 1-р давхар",
    flower: "Байгаа",
    plant: "Байгаа",
    internationalFood: "Олон үндэстний хоол",
    selfCheckout: "Байгаа",
    cando: "Байгаа",
    pharmacy: "Ситифарм",
    bakery: "Gute bakery",
    atm: "Хаан, Төрийн банк",
    type: "Хайпермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.859187499999976,
    longitude: 106.78543750000006,
    district: "Хан-Уул",
    image: "https://assets.nomin.mn/web/nomin-branches/nisekh.webp",
  },
  {
    name: "Андууд",
    plusCode: "WV8P+3J",
    addressText:
      "Баянгол дүүрэг, Энхтайваны өргөн чөлөө, 2-р хороо, ТБД Андууд",
    flower: "Гүнжид Дарь ХХК-Амьд цэцэг худалдаа",
    pharmacy: "Сити фарм -Эмийн сан",
    atm: "Голомт банк",
    type: "Супермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.91518749999999,
    longitude: 106.88656250000008,
    district: "Баянгол",
    image: "https://assets.nomin.mn/web/nomin-branches/anduud.webp",
  },
  {
    name: "Москва хороолол",
    plusCode: "WR6H+H7",
    addressText:
      "Сонгинохайрхан дүүрэг, Москва хороолол, 18070, Москвагийн гудамж , 125",
    flower: "Анхилуун flower",
    fastFood: "PIZZA",
    pharmacy: "Монос",
    gooSaihan: "Fabarlic Ballance Үсчин",
    atm: "Хаан банк ХХБанк",
    type: "Супермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.91143749999999,
    longitude: 106.82818750000001,
    district: "Сонгинохайрхан",
    image: "https://assets.nomin.mn/web/nomin-branches/moskva.webp",
  },
  {
    name: "Ховд",
    plusCode: "2M27+WWH",
    addressText: "Ховд аймаг, Жаргалант сум 9-р баг Ямаат улаан-7 01 тоот",
    internationalFood: "Олон үндэстний хоол",
    coffee: "Кофе шоп",
    motorcycle: "wonderer, keeway",
    pharmacy: "Өгөөж тун фарм",
    phoneAccessory: "Гар утас, дагалдах хэрэгсэл",
    gooSaihan: "Mild cosmetics",
    bakery: "Өнхрүүш бэйкери",
    atm: "Хаан, Голомт АТМ",
    selfWashing: "Dudu laundry",
    type: "Орон нутаг АХ",
    timetable: "Даваа-Баасан 09:00-22:00, Бямба 09:00-22:00, Ням 09:00-21:30",
    latitude: 48.002312,
    longitude: 91.664812,
    district: "Ховд",
    image: "https://assets.nomin.mn/web/nomin-branches/hovd.webp",
  },
  {
    name: "Зайсан",
    plusCode: "VWF5+M4",
    addressText:
      "Хан-уул дүүрэг, 11-р хороо, White Hill Residence хотхон, 100/9 байр",
    flower: "Luxury Flowers",
    coffee: "Restime coffee shop",
    pharmacy: "Сити фарм",
    phoneAccessory: "Цэнгүүн",
    bakery: "Атар хишиг",
    atm: "Голомт банк",
    type: "Супермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.87418749999999,
    longitude: 106.90781249999998,
    district: "Хан-уул",
    image: "https://assets.nomin.mn/web/nomin-branches/zaisan.webp",
  },
  {
    name: "Хэнтий",
    plusCode: "8M93+P49",
    addressText:
      "Хэнтий аймаг, Хэрлэн сум, 1-р баг, Тэмүүжингийн гудамж, Ж-02 тоот",
    internationalFood: "Олон үндэстний хоол",
    motorcycle: "wonderer, keeway",
    gooSaihan: "Mild Cosmetic",
    bakery: "Бэйкери",
    atm: "Хаан АТМ",
    type: "Орон нутаг АХ",
    timetable: "Даваа-Баасан 09:00-22:00, Бямба 09:00-22:00, Ням 09:00-21:30",
    latitude: 47.319288,
    longitude: 110.652859,
    district: "Хэнтий",
    image: "https://assets.nomin.mn/web/nomin-branches/chingis.webp",
  },
  {
    name: "Дорноговь",
    plusCode: "V4WP+7P9",
    addressText:
      "Дорноговь аймаг, Сайншанд сум 3-р баг Ноён хутагтын 2-202 тоот",
    fastFood: "Pizza",
    internationalFood: "Олон үндэстний хоол",
    motorcycle: "wonderer, keeway",
    pharmacy: "Монос фарм",
    phoneAccessory: "Жи мобайл",
    atm: "АТМ",
    type: "Орон нутаг АХ",
    timetable: "Даваа-Баасан 09:00-22:00, Бямба 09:00-22:00, Ням 09:00-21:30",
    latitude: 44.896094812013786,
    longitude: 110.13695783069059,
    district: "Дорноговь",
    image: "https://assets.nomin.mn/web/nomin-branches/sainshand.webp",
  },
  {
    name: "УБИ АХ",
    plusCode: "WQ5W+XW6",
    addressText:
      "Сонгинохайрхан дүүрэг, 20-р хороо, Орбитын гудамж, Улаанбаатар Импэкс",
    motorcycle: "wonderer, keeway",
    type: "Агуулах худалдаа",
    timetable: "Даваа-Баасан 09:00-20:00, Бямба 09:00-20:00, Ням 09:00-20:00",
    latitude: 47.9099375,
    longitude: 106.79731250000003,
    district: "Сонгинохайрхан",
    image: "https://assets.nomin.mn/web/nomin-branches/ubi.webp",
  },
  {
    name: "1-р хороолол салбар",
    plusCode: "WR8R+27",
    addressText:
      "Сүхбаатар дүүрэг, 15-р хороо, 1-р хороолол, Өнөр плаза, 1-р давхар",
    flower: "Zaya Premium Flower",
    pharmacy: "Эй Эм Ти дэлгэрэх ХХК",
    phoneAccessory: "Шижирбаатар",
    atm: "Хаан, төрийн банк,ХХБ",
    type: "Супермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.91506249999999,
    longitude: 106.84068750000006,
    district: "Сүхбаатар",
    image: "https://assets.nomin.mn/web/nomin-branches/unur.webp",
  },
  {
    name: "Чулуун-Овоо",
    plusCode: "WX6G+GP",
    addressText: "Баянзүрх дүүрэг, 12-р хороо, Нарны зам 1-38",
    flower: "Цэцэг",
    internationalFood: "Олон үндэстний хоол",
    motorcycle: "wonderer, keeway",
    pharmacy: "Монос фарм",
    phoneAccessory: "Гар утасны дэлгэцний наалт",
    bakery: "Атархишиг бэйкери",
    atm: "Хаан, Голомт, ХХБ АТМ",
    glasses: "Нүдний шил",
    type: "Агуулах худалдаа",
    timetable: "Даваа-Баасан 08:45-22:00, Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.911312499999994,
    longitude: 106.9768125,
    district: "Баянзүрх",
    image: "https://assets.nomin.mn/web/nomin-branches/chuluunowoo.webp",
  },
  {
    name: "Скай-таун",
    addressText:
      "Баянзүрх дүүрэг, 13-р хороо, Энхтайваны өргөн чөлөө 89-р байр",
    flower: "Байгаа",
    plusCode: "WX87+F6",
    plant: "Байгаа",
    fastFood: "Pizza Hut",
    internationalFood: "Олон үндэстний хоол",
    cando: "Байгаа",
    pharmacy: "Монос",
    gooSaihan: "Face shop",
    bakery: "Жүр үр",
    atm: "Голомт, Хаан",
    glasses: "Байгаа",
    type: "Хайпермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.91618749999999,
    longitude: 106.96306249999998,
    district: "Баянзүрх",
    image: "https://assets.nomin.mn/web/nomin-branches/skytown.webp",
  },
  {
    name: "Мишээл АХ",
    plusCode: "VVRP+9R",
    addressText: "Хан-Уул дүүрэг, 2-р хороо, Мишээл Номин Агуулах худалдаа",
    flower: "Цэцэг",
    internationalFood: "Милая",
    motorcycle: "wonderer, keeway",
    pharmacy: "Мөнх наст улиас эмин сан",
    type: "Агуулах худалдаа",
    timetable: "Даваа-Бямба 09:00-22:00, Бямба 09:00-22:00, Ням 09:00-21:30",
    latitude: 47.89093749999999,
    longitude: 106.88706250000007,
    district: "Хан-Уул",
    image: "https://assets.nomin.mn/web/nomin-branches/misheel.webp",
  },
  {
    name: "7-н буудал",
    plusCode: "XW99+W2",
    addressText: "Сүхбаатар дүүрэг, 14-р хороо, 7-н буудал, Бүрэн Плаза төв",
    fastFood: "PIZZA",
    pharmacy: "Сити фарм",
    bakery: "Жүр үр",
    type: "Супермаркет",
    timetable: "Даваа-Бямба 08:45-22:00, Ням 09:00-22:00",
    latitude: 47.9698125,
    longitude: 106.91756249999997,
    district: "Сүхбаатар",
    image: "https://assets.nomin.mn/web/nomin-branches/7buudal.webp",
  },
  {
    name: "Баян-өлгий",
    plusCode: "XX67+67",
    addressText:
      "Баян-Өлгий, Өлгий хот, 13-р баг, Жана ауыл, Антенн-4 гудамж, 411 тоот",
    flower: "Ханкрафт гар урлал",
    internationalFood: "Олон үндэстний хоол",
    motorcycle: "wonderer, keeway",
    pharmacy: "Эмийн сан",
    bakery: "Манка бэйкери",
    atm: "Хаан АТМ",
    type: "Орон нутаг АХ",
    timetable: "Даваа-Баасан 09:00-22:00, Бямба 09:00-22:00, Ням 09:00-21:30",
    latitude: 48.960812,
    longitude: 89.963188,
    district: "Баян-Өлгий",
    image: "https://assets.nomin.mn/web/nomin-branches/ulgii.webp",
  },
]

export const NOMIN_BRANCH_CODES = [
  // UB
  {
    title: "naadam",
    code: "170627000793100000",
    name: "Наадам центр ХМ",
  },
  {
    title: "united",
    code: "201401220000000001",
    name: "Юнайтед ХМ",
  },
  {
    title: "unur",
    code: "200912070000000001",
    name: "Өнөр ХМ",
  },
  {
    title: "uid",
    code: "2007121500003",
    name: "УИД ХМ",
  },
  {
    title: "allmart",
    code: "2007121500006",
    name: "13 ХМ",
  },
  {
    title: "guchin",
    code: "2007122200001",
    name: "32-н тойрог ХМ",
  },
  {
    title: "sedar",
    code: "210711648233200000",
    name: "Седар ХМ",
  },
  {
    title: "plaza",
    code: "2007121500004",
    name: "Плаза ХМ",
  },
  {
    title: "skytown",
    code: "199006080000000001",
    name: "Скайтаун ХМ",
  },
  {
    title: "aravhoroolol",
    code: "2007121500007",
    name: "10-р хороолол ХМ",
  },
  {
    title: "niseh",
    code: "211026775684300000",
    name: "Нисэх ХМ",
  },
  {
    title: "yarmag",
    code: "191111861584200000",
    name: "Яармаг ХМ",
  },
  {
    title: "nid",
    code: "2007121500002",
    name: "НИД",
  },
  {
    title: "bileg",
    code: "2007121500008",
    name: "ЭНЭШТ СМ",
  },
  {
    title: "ubi",
    code: "180627139631100000",
    name: "УБИ ХМ",
  },
  {
    title: "narniikhoroolol",
    code: "201402120000000001",
    name: "Нарны хороолол СМ",
  },
  {
    title: "anduud",
    code: "199010200000000001",
    name: "Андууд СМ",
  },
  {
    title: "hanuul",
    code: "201101070000000001",
    name: "Хан-Уул АХ",
  },
  {
    title: "zuunduruv",
    code: "180622135289300000",
    name: "Зүүн 4 зам СМ",
  },
  {
    title: "chuluunovoo",
    code: "201207020000000001",
    name: "Чулуун-Овоо АХ",
  },
  {
    title: "jukow",
    code: "180502083382800000",
    name: "Жуков СМ",
  },
  {
    title: "khorinkhoyrtovchoo",
    code: "201405090000000001",
    name: "22-н товчоо СМ",
  },
  {
    title: "arvannegkhoroolol",
    code: "201409170000000001",
    name: "11-р хороолол СМ",
  },
  {
    title: "buren",
    code: "190613594388200000",
    name: "7-н буудал СМ",
  },
  {
    title: "zunjin",
    code: "190726671387500000",
    name: "Зунжин СМ",
  },
  {
    title: "moskow",
    code: "191008798181100000",
    name: "Москва хороолол СМ",
  },
  {
    title: "narniiguur",
    code: "191008798184300000",
    name: "Нарны гүүр СМ",
  },
  {
    title: "azjargal",
    code: "191219911827500000",
    name: "Аз жаргал СМ",
  },
  {
    title: "negkhoroolol",
    code: "200206976661400000",
    name: "Өнөр плаза СМ",
  },
  {
    title: "whitehill",
    code: "220429027174500000",
    name: "Зайсан СМ",
  },
  {
    title: "baynzurh",
    code: "220804171645400000",
    name: "Баянзүрх АХ",
  },
  {
    title: "rapid",
    code: "230921000481800000",
    name: "Рапид хотхон СМ",
  },
  {
    title: "rivergarden",
    code: "200801310000001",
    name: "Ривэр Гарден СМ",
  },
  {
    title: "selbe",
    code: "230622001089600000",
    name: "Сэлбэ СМ",
  },
  {
    title: "makro",
    code: "240822000715900000",
    name: "Макро АХ",
  },
  {
    title: "ikhmongol",
    code: "200328033910800000",
    name: "Их Монгол СМ",
  },
  {
    title: "baynkhoshuu",
    code: "230122421485600000",
    name: "Баянхошуу АХ",
  },
  {
    title: "elecronics",
    code: "200809240000000001",
  },

  // Countryside
  { title: "uvs", code: "200613142471000000", name: "Улаангом АХ" },
  {
    title: "khovd",
    code: "2007121500012",
    name: "Ховд АХ",
  },
  {
    title: "darkhan",
    code: "2007121500010",
    name: "Дархан АХ",
  },
  {
    title: "arvaikheer",
    code: "190626618269100000",
    name: "Арвайхээр АХ",
  },
  {
    title: "zamiinuud",
    code: "200605133492300000",
    name: "Замын-Үүд АХ",
  },
  {
    title: "ulgii",
    code: "220733168857700000",
    name: "Өлгий АХ",
  },
  {
    title: "mandalgovi",
    code: "220804171646000000",
    name: "Мандалговь АХ",
  },
  {
    title: "bayankhongor",
    code: "241205000391700000",
    name: "Баянхонгор АХ",
  },
  {
    title: "dornod",
    code: "198912290000000001",
    name: "Хэрлэн АХ",
  },
  {
    title: "dalanzadgad",
    code: "201109270000000001",
    name: "Даланзадгад АХ",
  },
  {
    title: "erdenet",
    code: "201310110000000001",
    name: "Эрдэнэт АХ",
  },
  {
    title: "erdenetsm",
    code: "2007121500011",
    name: "Эрдэнэт СМ",
  },
  {
    title: "sukhbaatar",
    code: "201312240000000001",
    name: "Баруун-Урт АХ",
  },
  {
    title: "khuvsgul",
    code: "180606117831300000",
    name: "Мөрөн АХ",
  },
  {
    title: "dornogovi",
    code: "150421495744300001",
    name: "Сайншанд АХ",
  },
  {
    title: "undurkhaan",
    code: "190612592457900000",
    name: "Чингис АХ",
  },
  {
    title: "zuunmod",
    code: "181227350099900000",
    name: "Зуунмод СМ",
  },
]
